import React from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import Button from "@material-ui/core/Button";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { useHistory } from "react-router-dom";
import { Menu, MenuItem } from "@material-ui/core";
const useStyles = makeStyles({
  list: {
    width: "30vw",
    "@media(max-width:1200px)": {
      width: "37vw",
    },
    "@media(max-width:1000px)": {
      width: "42vw",
    },
    "@media(max-width:800px)": {
      width: "54vw",
    },
    "@media(max-width:600px)": {
      width: "70vw",
    },

    height: "140vh",
    backgroundColor: "rgba(15, 49, 55, 1)",
    color: "white",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    // paddingTop: "1.5vh",
    paddingBottom: "2vh",
    marginBottom: "auto",
  },
  item: {
    color: "white",
    paddingTop: "2.5vh",

    "@media(max-width:600px)": {
      paddingTop: "1vh",
    },
  },
  itemText: {
    fontFamily: "Poppins !important",
    fontSize: "17px",
    fontStyle: "normal",
    fontWeight: "500",
    lineHeight: "39px",
    letterSpacing: "0.1em",
    textAlign: "center",

    "@media(max-width:600px)": {
      fontSize: "12px",
    },
    "@media(max-width:400px)": {
      fontSize: "10px",
    },
  },
  buyBtn: {
    width: "11rem",
    height: "3rem",
    fontFamily: "Poppins",
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: "500",
    lineHeight: "27px",
    letterSpacing: "0em",
    textAlign: "left",
    borderRadius: "10px",
    color: "#1c454c",
    backgroundColor: "#fdcd0b",
    transition: "transform 0.3s",
    "&:hover": {
      backgroundColor: "#fdd224",
      transform: "scale(1.1)",
    },
  },
  none: {
    display: "none",
  },
  crossBtn: {
    marginLeft: "18rem",
    flex: 0.1,
    "@media(max-width:600px)": {
      marginLeft: "10rem",
    },
  },
});

export default function TemporaryDrawer() {
  const classes = useStyles();
  const [state, setState] = React.useState({
    right: false,
  });
  const history = useHistory();
  const toggleDrawer = (anchor, open) => event => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };
  const [live, setLive] = React.useState(false);

  React.useEffect(() => {
    const end_timestamp = 1622487600;
    // web3_obj && web3_obj.init();

    var x = setInterval(function () {
      // Get today's date and time
      const currentDate = new Date();
      const now = parseInt(currentDate.getTime().toString().slice(0, -3));

      // Find the distance between now and the count down date
      var distance = end_timestamp - now;

      // Time calculations for days, hours, minutes and seconds
      var days = Math.floor(distance / (60 * 60 * 24));
      var hours = Math.floor((distance % (60 * 60 * 24)) / (60 * 60));
      var minutes = Math.floor((distance % (60 * 60)) / 60);
      var seconds = Math.floor(distance % 60);

      // Display the result in the element with id="demo"
      // setTimer({
      //   days: days,
      //   hours: hours,
      //   minutes: minutes,
      //   seconds: seconds,
      // });

      // If the count down is finished, write some text
      if (distance < 0) {
        clearInterval(x);
        // setTimer();
        setLive(true);
      }
    }, 1000);
  }, []);
  const list = anchor => (
    <div
      className={clsx(classes.list)}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <List style={{ flex: 0.8 }}>
        <ListItem
          className={clsx(classes.item)}
          style={{ textAlign: "center", fontFamily: "Poppins" }}
          button
          key="cross"
        >
          <ListItemText>
            <Button
              className={clsx(classes.crossBtn)}
              style={{ textTransform: "none" }}
            >
              <img width="25px" src="cross.png" alt="cross" />
            </Button>
          </ListItemText>
        </ListItem>
        <ListItem
          className={clsx(classes.item)}
          style={{ textAlign: "center" }}
          button
          key="home"
          onClick={() => history.push("/")}
        >
          <ListItemText>
            <span className={clsx(classes.itemText)}>HOME</span>
          </ListItemText>
        </ListItem>
        {/* target="_blank"
            rel="noopener noreferrer"
            href="https://testnet.bscscan.com/address/0x373b45918e2C94Ef262207c9106AF78b2239c997#code" */}

        <ListItem
          className={clsx(classes.item)}
          style={{ textAlign: "center" }}
          button
          key="whitepaper"
          onClick={() => history.push("/whitepaper")}
        >
          <ListItemText>
            <span className={clsx(classes.itemText)}>WHITEPAPER</span>
          </ListItemText>
        </ListItem>
        <ListItem
          className={clsx(classes.item)}
          style={{ textAlign: "center" }}
          button
          key="whitepaper2"
          onClick={() => history.push("/whitepaper2")}
        >
          <ListItemText>
            <span className={clsx(classes.itemText)}>WHITEPAPER-TEXT</span>
          </ListItemText>
        </ListItem>
        <ListItem
          className={clsx(classes.item)}
          style={{ textAlign: "center" }}
          button
          key="litepaper"
          onClick={() => history.push("/litepaper")}
        >
          <ListItemText>
            <span className={clsx(classes.itemText)}>LITEPAPER</span>
          </ListItemText>
        </ListItem>
        <ListItem
          className={clsx(classes.item)}
          style={{ textAlign: "center" }}
          button
          key="audit report"
          onClick={() => history.push("/audit")}
        >
          <ListItemText>
            <span className={clsx(classes.itemText)}>AUDIT REPORT</span>
          </ListItemText>
        </ListItem>
        <ListItem
          className={clsx(classes.item)}
          style={{ textAlign: "center" }}
          button
          key="tut"
          onClick={() => history.push("/tutorial")}
        >
          <ListItemText>
            <span className={clsx(classes.itemText)}>TUTORIAL</span>
          </ListItemText>
        </ListItem>
        <ListItem
          className={clsx(classes.item)}
          style={{ textAlign: "center" }}
          button
          key="contr"
        >
          <ListItemText>
            <span className={clsx(classes.itemText)}>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://bscscan.com/address/0x4e2b998ecb7b6ef78c6a93ac1f5df9e6063a8fff"
                style={{
                  textDecoration: "none",
                  color: "white",
                }}
              >
                CONTRACT
              </a>
            </span>
          </ListItemText>
        </ListItem>
        <ListItem key="referral">
          <ListItemText>
            <span className={clsx(classes.itemText)}>
              <p
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  textDecoration: "none",
                  color: "white",
                  cursor: "pointer",
                }}
                onClick={() => history.push("/referral")}
              >
                REFERRALS
              </p>
            </span>
          </ListItemText>
        </ListItem>
        <ListItem
          className={clsx(classes.item)}
          style={{ textAlign: "center" }}
          button
          key="medium"
        >
          <ListItemText>
            <span className={clsx(classes.itemText)}>
              <a
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  textDecoration: "none",
                  color: "white",
                }}
                href="https://cefatoken.medium.com/"
              >
                MEDIUM
              </a>
            </span>
          </ListItemText>
        </ListItem>
        <ListItem
          className={clsx(classes.item)}
          style={{ textAlign: "center" }}
          button
          key="youtube"
        >
          <ListItemText>
            <span className={clsx(classes.itemText)}>
              <a
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  textDecoration: "none",
                  color: "white",
                }}
                href="https://www.youtube.com/playlist?list=PLfb8Qomp_Dd-9WD2tLcjNV3jGp2ncpUV0"
              >
                YOUTUBE
              </a>
            </span>
          </ListItemText>
        </ListItem>
        <ListItem
          className={clsx(classes.item)}
          style={{ textAlign: "center" }}
          button
          key="twitter"
        >
          <ListItemText>
            <span className={clsx(classes.itemText)}>
              <a
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  textDecoration: "none",
                  color: "white",
                }}
                href="https://twitter.com/CEFAToken"
              >
                TWITTER
              </a>
            </span>
          </ListItemText>
        </ListItem>
        <ListItem
          className={clsx(classes.item)}
          style={{ textAlign: "center" }}
          button
          key="discord"
        >
          <ListItemText>
            <span className={clsx(classes.itemText)}>
              <a
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  textDecoration: "none",
                  color: "white",
                }}
                href="https://discord.gg/Qek3eMeHDk"
              >
                DISCORD
              </a>
            </span>
          </ListItemText>
        </ListItem>
        <ListItem
          className={clsx(classes.item)}
          style={{ textAlign: "center" }}
          button
          key="telegram"
        >
          <ListItemText>
            <span className={clsx(classes.itemText)}>
              <a
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  textDecoration: "none",
                  color: "white",
                }}
                href="https://t.me/CEFAToken"
              >
                TELEGRAM
              </a>
            </span>
          </ListItemText>
        </ListItem>
        <ListItem
          className={clsx(classes.item)}
          style={{
            // fontFamily: "Poppins",
            textAlign: "center",
            // height: "50px",
            color: "#FDCD0B",
          }}
          button
          key="more"
        >
          <ListItemText>
            <span className={clsx(classes.itemText)}>MORE</span>
          </ListItemText>
        </ListItem>
        <ListItem
          className={clsx(classes.item)}
          style={{ textAlign: "center", fontFamily: "Poppins" }}
          button
          key="button"
        >
          <ListItemText>
            <Button
              className={live ? clsx(classes.none) : clsx(classes.buyBtn)}
              variant="contained"
              style={{ textTransform: "none" }}
              onClick={() => history.push({ pathname: "whitepaper" })}
            >
              Learn More
            </Button>
            <Button
              className={!live ? clsx(classes.none) : clsx(classes.buyBtn)}
              variant="contained"
              style={{ textTransform: "none" }}
              onClick={() => history.push({ pathname: "/sale" })}

              // onClick={() => history.push({ pathname: "whitepaper" })}
            >
              <a href="#" style={{ textDecoration: "none", color: "#1c454c" }}>
                Participate
              </a>
            </Button>
          </ListItemText>
        </ListItem>
      </List>
    </div>
  );
  let src = "hamburger.png";
  if (window.innerWidth < 1000) {
    src = "hamm.png";
  } else src = "hamburger.png";

  let hamWidth = "32px";
  if (window.innerWidth < 600) hamWidth = "26px";
  else hamWidth = "32px";
  return (
    <div>
      <Button onClick={toggleDrawer("right", true)}>
        <img
          src={src}
          width={hamWidth}
          alt="ham"
          style={{ objectFit: "contain" }}
        />
      </Button>
      <Drawer
        anchor="right"
        open={state["right"]}
        onClose={toggleDrawer("right", false)}
      >
        {list("right")}
      </Drawer>
    </div>
  );
}
